mapboxgl.accessToken = 'pk.eyJ1IjoiZGF2aWRzLW1vZGUiLCJhIjoiY2tnZGI2dm5mMDV2eDJyczRyejZ2c3I2cSJ9.GQ8NXKG4Nd5jQMO7Z4Dlqw';

export default function initMap(selector) {
    const $el = jQuery(`#${selector}`);

    const dataCoord = $el.data('coord');
    const initCoord = dataCoord ? dataCoord.split(',') : [9.176277, 47.646315];

    const zoom = $el.data('zoom');

    const map = new mapboxgl.Map({
        container: selector,
        style: 'mapbox://styles/mapbox/dark-v10',
        center: initCoord, // starting position [lng, lat]
        zoom: parseFloat(zoom) || 15,
        minZoom: 9.5,
        scrollZoom: false,
        touchZoomRotate: false
    })
        .addControl(new mapboxgl.NavigationControl())
        .on('load', function() {
            this
                .setLayoutProperty('country-label', 'text-field', ['get', 'name_de'])
                .setLayoutProperty('waterway-label', 'text-field', ['get', 'name_de'])
                .setLayoutProperty('water-line-label', 'text-field', ['get', 'name_de'])
                .setLayoutProperty('water-point-label', 'text-field', ['get', 'name_de'])
                .setLayoutProperty('settlement-label', 'text-field', ['get', 'name_de'])
                .setLayoutProperty('state-label', 'text-field', ['get', 'name_de']);
        });

    const markerEl = document.createElement('div');
    markerEl.className = 'dmode-map-marker';

    const marker = new mapboxgl.Marker({
        element: markerEl,
        color: '#ffffff',
    })
        .setLngLat(initCoord)
        .addTo(map);
    const popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
        offset: 10
    })
        .setLngLat(initCoord)
        .setHTML($el.find('.popup-content').html())
        .addTo(map);

}